import { Stack, Typography } from '@mui/material';

import { tApp } from '@frontend/locales';

import { QrCodeDisplay } from '../qr-code-display.component';

export interface AccountDetailsQrProps {
  token: string;
}

export const AccountDetailsQr = (props: AccountDetailsQrProps) => {
  return (
    <Stack spacing={2} alignItems="center" marginBottom={10}>
      <QrCodeDisplay
        value={JSON.stringify({
          t: 'pt',
          k: props.token,
        })}
      />
      <Typography variant="h3" align="center">
        {tApp.accountDetails.scanToIdentify()}
      </Typography>
    </Stack>
  );
};
